import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoneyBag = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17 14L14 9H26L23 14",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 14H17C17 14 11 20.364 11 25C11 28.091 13.251 31 20 31C26.749 31 29 28.091 29 25C29 20.364 23 14 23 14Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.9988 24.868C23.009 25.2163 22.9523 25.5628 22.8332 25.8807C22.714 26.1985 22.5355 26.4792 22.3116 26.701C21.7557 27.2067 21.0842 27.496 20.3873 27.53V29H19.5692V27.558C18.6911 27.5576 17.8219 27.3479 17.0118 26.941V25.048C17.4128 25.2774 17.8313 25.4599 18.2614 25.593C18.688 25.7379 19.1255 25.8317 19.5676 25.873V23.649L19.1669 23.463C18.54 23.2118 17.9675 22.7964 17.4908 22.247C17.1604 21.8005 16.9851 21.2189 17.001 20.622C16.9959 20.2934 17.0545 19.9679 17.1722 19.6711C17.2899 19.3743 17.4634 19.1145 17.6791 18.912C18.2284 18.4223 18.8866 18.1397 19.5701 18.1V17H20.3881V18.069C21.2401 18.1002 22.0794 18.3242 22.8622 18.729L22.3008 20.407C21.6897 20.1041 21.0435 19.9155 20.3848 19.848V21.964C20.9622 22.2074 21.5178 22.5196 22.0433 22.896C22.336 23.1155 22.583 23.4124 22.7656 23.764C22.9249 24.1 23.0055 24.4815 22.9988 24.868ZM18.7987 20.622C18.7963 20.7193 18.8113 20.8161 18.8428 20.9058C18.8743 20.9955 18.9214 21.0761 18.9811 21.142C19.1575 21.3188 19.3563 21.4606 19.5701 21.562V19.876C19.0564 19.9673 18.7992 20.216 18.7987 20.622ZM21.2011 24.976C21.2015 24.8782 21.1834 24.7816 21.1482 24.6935C21.113 24.6053 21.0616 24.5279 20.9979 24.467C20.8117 24.2912 20.6066 24.1462 20.3881 24.036V25.822C20.9296 25.712 21.2006 25.43 21.2011 24.976Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgMoneyBag);
export default ForwardRef;
